<template>


<div>




  <div style="background-color:#f6f6f6;background-image:url('/static/geofolio-iso.svg');border-bottom:1px solid #ddd;padding-top:6px;">

      <div class="container" style="background-color:rgba(255,255,255,0.85);border-right:1px solid #ddd;border-top:1px solid #ddd;border-left:1px solid #ddd;">


          <nav class="navbar navbar-expand-lg" style="background:none;padding:5px 0px;">
              


          <div class="mx-auto order-0">

                      <router-link v-if="(profile && (profile.is_public == false))" :to="{ name: 'home' }" class="ldr-home-link" style="background-color:#fff !important;border:none !important;">
                        <img src="/static/geofolio-logo.svg" style="height:45px;margin-bottom:15px;margin-top:15px;margin-right:10px;float:none;">
                      </router-link>
                      <a href="/" v-else  class="ldr-home-link" style="background-color:#fff !important;border:none !important;">
                        <img src="/static/geofolio-logo.svg" style="height:45px;margin-bottom:15px;margin-top:15px;margin-right:10px;float:none;">
                      </a>

                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".dual-collapse2" style="padding:0px; margin:0px;font-size:2em;background-color:#eee;border-radius:0px;"><i class="bi bi-list"></i></button>
                    </div>

              <div class="navbar-collapse w-100 order-1 order-md-0 dual-collapse2" style="font-size:16px;">
                  <ul class="navbar-nav mr-auto">

                      <li class="nav-item">

                          <span v-if="(profile && (profile.is_public == false))" style="margin-left:5px;background-color:white;border:1px solid #eee;border-radius:5px; padding:3px 7px;margin-right:5px;color:#666;background-color:#fff;"><div style="width:10px;height:10px;margin-right:5px;display:inline-block;background-color:#84ba45;border-radius:10px;font-size:16px;"></div>Logged in as <strong>{{ profile.username }}</strong></span>

                          <span v-else style="margin-left:5px;background-color:white;border:1px solid #eee;border-radius:5px; padding:3px 7px;margin-right:5px;color:#666;background-color:#fff;"><div style="width:10px;height:10px;margin-right:5px;display:inline-block;background-color:#bbb;border-radius:10px;font-size:16px;"></div>You are viewing Geofolio as a <strong>public user</strong></span>
                      </li>


                  </ul>

              </div>

    
              


              <div class="navbar-collapse w-100 order-3 dual-collapse2"  v-if="(profile && (profile.is_public == false))">

                  <ul class="navbar-nav ml-auto"> 
                      <li class="nav-item nav-item-link"><a href="/" class="nav-link" style="padding-right:0px;font-size:16px;border:none !important;"><i class="bi bi-arrow-up-left"></i> Back to Geofolio homepage</a></li>

                      
                  </ul>

              </div>
              <div class="navbar-collapse w-100 order-3 dual-collapse2"  v-else>

                  <ul class="navbar-nav ml-auto">                          
                      <li id="link-register" class="nav-item" style="margin-right:10px;">
                          <router-link :to="{ name: 'signup' }" class="nav-link separate">Sign up</router-link>
                      </li>
                      <li id="link-register" class="nav-item" style="margin-right:10px;">
                          <router-link :to="{ name: 'login' }" class="nav-link separate"><i class="bi bi-person-fill"></i> Log in</router-link>
                      </li>
                  </ul>

              </div>


          </nav>

        
      </div>
  </div>



<div class="container" style="padding-top:10px;padding-bottom:10px;background-color:#fff;border-right:1px solid #ddd;border-left:1px solid #ddd;border-bottom:0px solid #ddd;">


  <nav class="navbar navbar-expand-lg" style="background:none;padding:5px 0px;font-size:16px;" v-if="(profile && (profile.is_public == false))">


                <div class="navbar-collapse  w-100 order-1 order-sm-0 dual-collapse2">
                  <ul class="navbar-nav mr-auto">


                      <li class="nav-item" style="margin-right:10px;">
                          

                          <router-link :to="{ name: 'home' }"  class="nav-link">
                            <nobr><i class="bi bi-files"></i> Factsheets ({{ this.factsheets.length }})</nobr>
                          </router-link>
                      </li>

                      <li class="nav-item" style="margin-right:10px;" v-if="this.projects.length > 0">
                          <router-link :to="{ name: 'projects' }"  class="nav-link">
                            <nobr><i class="bi bi-archive"></i> Projects ({{ this.projects.length }})</nobr>
                            </router-link>
                      </li>
          
                      <li class="nav-item" style="margin-right:10px;">
                          <nobr><a class="nav-link separate" href="#" @click.prevent="createStart"><i class="bi bi-stars"></i> Create New Factsheet</a></nobr>
                      </li>

                  </ul>

              </div>





               <div class="navbar-collapse w-100 order-3 dual-collapse2" >


                  <ul class="navbar-nav ml-auto">  


                      
                      <li class="nav-item" style="margin-right:10px;">
                          <router-link :to="{ name: 'account' }"  class="nav-link"><i class="bi bi-sliders"></i> Account</router-link>
                      </li>
                      <li class="nav-item" style="margin-right:10px;">
                          <a class="nav-link separate" href="/"><i class="bi bi-box-arrow-up-right"></i> Admin</a>
                      </li>

                      <li class="nav-item">
                          <a class="nav-link separate" href="#" v-on:click.prevent="logOut('home')">Log out</a>
                      </li>

                  </ul>

              </div>
          </nav>

</div>






  </div>


</div>
</template>


<script>
  
  export default {
    name: 'mainheader',
    components: {
    },
    computed: {
        profile() {
          return this.getProfile();
        },
        factsheets() {
          return this.getFactsheets();
        },
        projects() {
          return this.getProjects();
        }
    },
    methods: {
      logOut(dest='home') {
        const headers = {
            'X-CSRFTOKEN': this.csrfcookie()
        }
        this.$axios
           .post(process.env.VUE_APP_API+"/api/logout", null, { headers: headers })
           .then(response => {
                this.$store.commit('profile', response.data.profile)
                this.$store.commit('profile_pub', response.data.profile_pub)
                this.$router.push('/')
           })
           .catch(error => {
               console.log("An error occurred while logging out.")
           })
      }
    }
  }
</script>

<style>

li.nav-item a {
  border:1px solid #f2f2f2;
  border-radius:0px;
  background-color:#f2f2f2;
  padding-left:15px !important;
  padding-right:15px !important;
}
li.nav-item a:hover {
  background-color:#e5e5e5;
}

li.nav-item-link a {
  background-color:#fff;
  padding:0px !important;
  margin:0px !important;
}


a.router-link-exact-active {
  background-color:#edf4ff !important;
  border:1px solid #b2c9ed !important;
  border:1px solid #edf4ff !important;
}


li.nav-item-link a:hover {
  background-color:#fff !important;
}

li.nav-item.nav-item-primary a {
  background-color:#007bff;
  color:#fff;
}
li.nav-item.nav-item-primary a:hover {
  background-color:#0069d9;
  border-color:#0069d9;
}


span.nav-block {
  border:0px solid #007bff;
  border-radius:0px;
  background-color:#f2f2f2;
  padding:5px 15px !important;
  color:#444;
}
</style>